import register from '../../../../global/js/registry';
export default register('o-teaser-grid', () => import(/* webpackMode: "lazy" */ './o-teaser-grid.controller'));
